<template>
    <v-dialog max-width="50%" v-model="dialog">
        <v-card class="ma-0 pa-0">
            <v-card-actions class="ma-0 pa-0">
                <v-spacer></v-spacer>
                <v-btn icon class="ma-1" color="red" @click="onClose">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-actions>
            <v-card-actions class="py-0">
                <v-textarea
                        v-if="area"
                        outlined
                        v-model="oldInfo"
                        label="Message"
                ></v-textarea>
                <v-text-field
                        v-else
                        outlined
                        v-model="oldInfo"
                        label="Message"
                ></v-text-field>
            </v-card-actions>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn class="ma-2"
                       color="primary"
                       @click="onPressSave">SAVE
                </v-btn>
                <v-spacer></v-spacer>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: "popup-edit-info",
    props: {},
    components: {},
    data: () => ({
        dialog: false,
        oldInfo: "",
        onComplete:null,
        area:false,
    }),
    computed: {
    },
    methods: {
        show(oldInfo, onComplete, area) {
            this.area = area
            this.dialog = true
            this.oldInfo = oldInfo
            this.onComplete = onComplete
        },
        hide() {
            this.dialog = false
        },
        onClose() {
            this.hide()
        },
        onPressSave() {
            this.dialog = false
            this.onComplete(this.oldInfo, this.getMessage())
        },
        getMessage(){
            let text = this.oldInfo
            if (text.length > 256){
                text = text.substring(0,256)
            }
            return text
        },
    },
}
</script>

<style scoped>

</style>